import { useReduxState } from 'hooks';
import { Alert } from 'components/common';

interface Props {
  styles?: React.CSSProperties;
}

const CourseUnsavedChaptersAlert = ({ styles = {} }: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const unsavedChapters = course?.chapters.filter((chapter) => chapter.isDraft);

  return unsavedChapters.length ? (
    <Alert
      expand={true}
      style={{ margin: '-5px 0 15px 0', ...styles }}
      text={unsavedChapters.map((chapter) => (
        <div key={chapter.number}>{`${chapter.number}. ${chapter.title}`}</div>
      ))}
      title={`${messages.manageExportPdfUnsavedChapters}:`}
      type="warning-light"
    />
  ) : null;
};

export default CourseUnsavedChaptersAlert;
